"use strict";

var _classCallCheck = require("/vercel/612421a5/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/612421a5/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _assertThisInitialized = require("/vercel/612421a5/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/vercel/612421a5/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/vercel/612421a5/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/vercel/612421a5/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var EventTargetImpl = require("../events/EventTarget-impl").implementation;

var _require = require("../helpers/internal-constants"),
    domSymbolTree = _require.domSymbolTree;

var _require2 = require("../../utils"),
    simultaneousIterators = _require2.simultaneousIterators;

var DOMException = require("domexception");

var NODE_TYPE = require("../node-type");

var NODE_DOCUMENT_POSITION = require("../node-document-position");

var NodeList = require("../generated/NodeList");

var _require3 = require("../helpers/document-base-url"),
    documentBaseURLSerialized = _require3.documentBaseURLSerialized;

var _require4 = require("../node"),
    clone = _require4.clone,
    locateNamespacePrefix = _require4.locateNamespacePrefix,
    locateNamespace = _require4.locateNamespace;

var attributes = require("../attributes");

function isObsoleteNodeType(node) {
  return node.nodeType === NODE_TYPE.ENTITY_NODE || node.nodeType === NODE_TYPE.ENTITY_REFERENCE_NODE || node.nodeType === NODE_TYPE.NOTATION_NODE || //  node.nodeType === NODE_TYPE.ATTRIBUTE_NODE ||  // this is missing how do we handle?
  node.nodeType === NODE_TYPE.CDATA_SECTION_NODE;
}

function nodeEquals(a, b) {
  if (a.nodeType !== b.nodeType) {
    return false;
  }

  switch (a.nodeType) {
    case NODE_TYPE.DOCUMENT_TYPE_NODE:
      if (a.name !== b.name || a.publicId !== b.publicId || a.systemId !== b.systemId) {
        return false;
      }

      break;

    case NODE_TYPE.ELEMENT_NODE:
      if (a._namespaceURI !== b._namespaceURI || a._prefix !== b._prefix || a._localName !== b._localName || a._attributes.length !== b._attributes.length) {
        return false;
      }

      break;

    case NODE_TYPE.PROCESSING_INSTRUCTION_NODE:
      if (a._target !== b._target || a._data !== b._data) {
        return false;
      }

      break;

    case NODE_TYPE.TEXT_NODE:
    case NODE_TYPE.COMMENT_NODE:
      if (a._data !== b._data) {
        return false;
      }

      break;
  }

  if (a.nodeType === NODE_TYPE.ELEMENT_NODE && !attributes.attributeListsEqual(a, b)) {
    return false;
  }

  var _iterator = _createForOfIteratorHelper(simultaneousIterators(domSymbolTree.childrenIterator(a), domSymbolTree.childrenIterator(b))),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var nodes = _step.value;

      if (!nodes[0] || !nodes[1]) {
        // mismatch in the amount of childNodes
        return false;
      }

      if (!nodeEquals(nodes[0], nodes[1])) {
        return false;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return true;
}

var NodeImpl = /*#__PURE__*/function (_EventTargetImpl) {
  _inherits(NodeImpl, _EventTargetImpl);

  var _super = _createSuper(NodeImpl);

  function NodeImpl(args, privateData) {
    var _this;

    _classCallCheck(this, NodeImpl);

    _this = _super.call(this);
    domSymbolTree.initialize(_assertThisInitialized(_this));
    _this._ownerDocument = privateData.ownerDocument;
    _this._childNodesList = null;
    _this._childrenList = null;
    _this._version = 0;
    _this._memoizedQueries = {};
    return _this;
  }

  _createClass(NodeImpl, [{
    key: "getRootNode",
    value: function getRootNode() {
      // ignore option for composed, because of no Shadow DOM support
      var root;

      var _iterator2 = _createForOfIteratorHelper(domSymbolTree.ancestorsIterator(this)),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var ancestor = _step2.value;
          root = ancestor;
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      return root;
    }
  }, {
    key: "insertBefore",
    value: function insertBefore(newChildImpl, refChildImpl) {
      // DocumentType must be implicitly adopted
      if (newChildImpl.nodeType === NODE_TYPE.DOCUMENT_TYPE_NODE) {
        newChildImpl._ownerDocument = this._ownerDocument;
      }

      if (newChildImpl.nodeType && newChildImpl.nodeType === NODE_TYPE.ATTRIBUTE_NODE) {
        throw new DOMException("The operation would yield an incorrect node tree.", "HierarchyRequestError");
      }

      if (this._ownerDocument !== newChildImpl._ownerDocument) {
        // adopt the node when it's not in this document
        this._ownerDocument.adoptNode(newChildImpl);
      } else {
        // search for parents matching the newChild
        var _iterator3 = _createForOfIteratorHelper(domSymbolTree.ancestorsIterator(this)),
            _step3;

        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var ancestor = _step3.value;

            if (ancestor === newChildImpl) {
              throw new DOMException("The operation would yield an incorrect node tree.", "HierarchyRequestError");
            }
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
      } // fragments are merged into the element (except parser-created fragments in <template>)


      if (newChildImpl.nodeType === NODE_TYPE.DOCUMENT_FRAGMENT_NODE) {
        var grandChildImpl;

        while (grandChildImpl = domSymbolTree.firstChild(newChildImpl)) {
          newChildImpl.removeChild(grandChildImpl);
          this.insertBefore(grandChildImpl, refChildImpl);
        }
      } else if (newChildImpl === refChildImpl) {
        return newChildImpl;
      } else {
        var oldParentImpl = domSymbolTree.parent(newChildImpl); // if the newChild is already in the tree elsewhere, remove it first

        if (oldParentImpl) {
          oldParentImpl.removeChild(newChildImpl);
        }

        if (refChildImpl === null) {
          domSymbolTree.appendChild(this, newChildImpl);
        } else {
          if (domSymbolTree.parent(refChildImpl) !== this) {
            throw new DOMException("The object can not be found here.", "NotFoundError");
          }

          domSymbolTree.insertBefore(refChildImpl, newChildImpl);
        }

        this._modified();

        if (newChildImpl.nodeType === NODE_TYPE.TEXT_NODE) {
          this._childTextContentChangeSteps();
        }

        if (this._attached && newChildImpl._attach) {
          newChildImpl._attach();
        }

        this._descendantAdded(this, newChildImpl);
      }

      return newChildImpl;
    } // raises(DOMException);

  }, {
    key: "_modified",
    value: function _modified() {
      this._version++;

      var _iterator4 = _createForOfIteratorHelper(domSymbolTree.ancestorsIterator(this)),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var ancestor = _step4.value;
          ancestor._version++;
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }

      if (this._childrenList) {
        this._childrenList._update();
      }

      if (this._childNodesList) {
        this._childNodesList._update();
      }

      this._clearMemoizedQueries();
    }
  }, {
    key: "_childTextContentChangeSteps",
    value: function _childTextContentChangeSteps() {// Default: do nothing
    }
  }, {
    key: "_clearMemoizedQueries",
    value: function _clearMemoizedQueries() {
      this._memoizedQueries = {};
      var myParent = domSymbolTree.parent(this);

      if (myParent) {
        myParent._clearMemoizedQueries();
      }
    }
  }, {
    key: "_descendantRemoved",
    value: function _descendantRemoved(parent, child) {
      var myParent = domSymbolTree.parent(this);

      if (myParent) {
        myParent._descendantRemoved(parent, child);
      }
    }
  }, {
    key: "_descendantAdded",
    value: function _descendantAdded(parent, child) {
      var myParent = domSymbolTree.parent(this);

      if (myParent) {
        myParent._descendantAdded(parent, child);
      }
    }
  }, {
    key: "replaceChild",
    value: function replaceChild(node, child) {
      this.insertBefore(node, child);
      return this.removeChild(child);
    }
  }, {
    key: "_attach",
    value: function _attach() {
      this._attached = true;

      var _iterator5 = _createForOfIteratorHelper(domSymbolTree.childrenIterator(this)),
          _step5;

      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var child = _step5.value;

          if (child._attach) {
            child._attach();
          }
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
    }
  }, {
    key: "_detach",
    value: function _detach() {
      this._attached = false;

      if (this._ownerDocument && this._ownerDocument._lastFocusedElement === this) {
        this._ownerDocument._lastFocusedElement = null;
      }

      var _iterator6 = _createForOfIteratorHelper(domSymbolTree.childrenIterator(this)),
          _step6;

      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var child = _step6.value;

          if (child._detach) {
            child._detach();
          }
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }
    }
  }, {
    key: "removeChild",
    value: function removeChild(
    /* Node */
    oldChildImpl) {
      if (!oldChildImpl || domSymbolTree.parent(oldChildImpl) !== this) {
        throw new DOMException("The object can not be found here.", "NotFoundError");
      }

      if (this._ownerDocument) {
        this._ownerDocument._runPreRemovingSteps(oldChildImpl);
      }

      domSymbolTree.remove(oldChildImpl);

      this._modified();

      oldChildImpl._detach();

      this._descendantRemoved(this, oldChildImpl);

      if (oldChildImpl.nodeType === NODE_TYPE.TEXT_NODE) {
        this._childTextContentChangeSteps();
      }

      return oldChildImpl;
    } // raises(DOMException);

  }, {
    key: "appendChild",
    value: function appendChild(newChild) {
      return this.insertBefore(newChild, null);
    }
  }, {
    key: "hasChildNodes",
    value: function hasChildNodes() {
      return domSymbolTree.hasChildren(this);
    }
  }, {
    key: "normalize",
    value: function normalize() {
      var _iterator7 = _createForOfIteratorHelper(domSymbolTree.childrenIterator(this)),
          _step7;

      try {
        for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
          var child = _step7.value;

          if (child.normalize) {
            child.normalize();
          } // Normalize should only transform Text nodes, and nothing else.


          if (child.nodeType !== NODE_TYPE.TEXT_NODE) {
            continue;
          }

          if (child.nodeValue === "") {
            this.removeChild(child);
            continue;
          }

          var prevChild = domSymbolTree.previousSibling(child);

          if (prevChild && prevChild.nodeType === NODE_TYPE.TEXT_NODE) {
            // merge text nodes
            prevChild.appendData(child.nodeValue);
            this.removeChild(child);
          }
        }
      } catch (err) {
        _iterator7.e(err);
      } finally {
        _iterator7.f();
      }
    }
  }, {
    key: "compareDocumentPosition",
    value: function compareDocumentPosition(otherImpl) {
      // Let reference be the context object.
      var reference = this;

      if (isObsoleteNodeType(reference) || isObsoleteNodeType(otherImpl)) {
        throw new Error("Obsolete node type");
      }

      var result = domSymbolTree.compareTreePosition(reference, otherImpl); // “If other and reference are not in the same tree, return the result of adding DOCUMENT_POSITION_DISCONNECTED,
      //  DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC, and either DOCUMENT_POSITION_PRECEDING or
      // DOCUMENT_POSITION_FOLLOWING, with the constraint that this is to be consistent, together.”

      if (result === NODE_DOCUMENT_POSITION.DOCUMENT_POSITION_DISCONNECTED) {
        // symbol-tree does not add these bits required by the spec:
        return NODE_DOCUMENT_POSITION.DOCUMENT_POSITION_DISCONNECTED | NODE_DOCUMENT_POSITION.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC | NODE_DOCUMENT_POSITION.DOCUMENT_POSITION_FOLLOWING;
      }

      return result;
    }
  }, {
    key: "lookupPrefix",
    value: function lookupPrefix(namespace) {
      if (namespace === null || namespace === "") {
        return null;
      }

      switch (this.nodeType) {
        case NODE_TYPE.ELEMENT_NODE:
          {
            return locateNamespacePrefix(this, namespace);
          }

        case NODE_TYPE.DOCUMENT_NODE:
          {
            return this.documentElement !== null ? locateNamespacePrefix(this.documentElement, namespace) : null;
          }

        case NODE_TYPE.DOCUMENT_TYPE_NODE:
        case NODE_TYPE.DOCUMENT_FRAGMENT_NODE:
          {
            return null;
          }

        case NODE_TYPE.ATTRIBUTE_NODE:
          {
            return this._element !== null ? locateNamespacePrefix(this._element, namespace) : null;
          }

        default:
          {
            return this.parentElement !== null ? locateNamespacePrefix(this.parentElement, namespace) : null;
          }
      }
    }
  }, {
    key: "lookupNamespaceURI",
    value: function lookupNamespaceURI(prefix) {
      if (prefix === "") {
        prefix = null;
      }

      return locateNamespace(this, prefix);
    }
  }, {
    key: "isDefaultNamespace",
    value: function isDefaultNamespace(namespace) {
      if (namespace === "") {
        namespace = null;
      }

      var defaultNamespace = locateNamespace(this, null);
      return defaultNamespace === namespace;
    }
  }, {
    key: "contains",
    value: function contains(other) {
      if (other === null) {
        return false;
      } else if (this === other) {
        return true;
      }

      return Boolean(this.compareDocumentPosition(other) & NODE_DOCUMENT_POSITION.DOCUMENT_POSITION_CONTAINED_BY);
    }
  }, {
    key: "isEqualNode",
    value: function isEqualNode(node) {
      if (node === null) {
        return false;
      } // Fast-path, not in the spec


      if (this === node) {
        return true;
      }

      return nodeEquals(this, node);
    }
  }, {
    key: "isSameNode",
    value: function isSameNode(node) {
      if (this === node) {
        return true;
      }

      return false;
    }
  }, {
    key: "cloneNode",
    value: function cloneNode(deep) {
      deep = Boolean(deep);
      return clone(this, undefined, deep);
    }
  }, {
    key: "parentNode",
    get: function get() {
      return domSymbolTree.parent(this);
    }
  }, {
    key: "nodeName",
    get: function get() {
      switch (this.nodeType) {
        case NODE_TYPE.ELEMENT_NODE:
          return this.tagName;

        case NODE_TYPE.TEXT_NODE:
          return "#text";

        case NODE_TYPE.CDATA_SECTION_NODE:
          return "#cdata-section";

        case NODE_TYPE.PROCESSING_INSTRUCTION_NODE:
          return this.target;

        case NODE_TYPE.COMMENT_NODE:
          return "#comment";

        case NODE_TYPE.DOCUMENT_NODE:
          return "#document";

        case NODE_TYPE.DOCUMENT_TYPE_NODE:
          return this.name;

        case NODE_TYPE.DOCUMENT_FRAGMENT_NODE:
          return "#document-fragment";
      } // should never happen


      return null;
    }
  }, {
    key: "firstChild",
    get: function get() {
      return domSymbolTree.firstChild(this);
    }
  }, {
    key: "isConnected",
    get: function get() {
      var _iterator8 = _createForOfIteratorHelper(domSymbolTree.ancestorsIterator(this)),
          _step8;

      try {
        for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
          var ancestor = _step8.value;

          if (ancestor.nodeType === NODE_TYPE.DOCUMENT_NODE) {
            return true;
          }
        }
      } catch (err) {
        _iterator8.e(err);
      } finally {
        _iterator8.f();
      }

      return false;
    }
  }, {
    key: "ownerDocument",
    get: function get() {
      return this.nodeType === NODE_TYPE.DOCUMENT_NODE ? null : this._ownerDocument;
    }
  }, {
    key: "lastChild",
    get: function get() {
      return domSymbolTree.lastChild(this);
    }
  }, {
    key: "childNodes",
    get: function get() {
      var _this2 = this;

      if (!this._childNodesList) {
        this._childNodesList = NodeList.createImpl([], {
          element: this,
          query: function query() {
            return domSymbolTree.childrenToArray(_this2);
          }
        });
      } else {
        this._childNodesList._update();
      }

      return this._childNodesList;
    }
  }, {
    key: "nextSibling",
    get: function get() {
      return domSymbolTree.nextSibling(this);
    }
  }, {
    key: "previousSibling",
    get: function get() {
      return domSymbolTree.previousSibling(this);
    }
  }, {
    key: "parentElement",
    get: function get() {
      var parentNode = domSymbolTree.parent(this);
      return parentNode !== null && parentNode.nodeType === NODE_TYPE.ELEMENT_NODE ? parentNode : null;
    }
  }, {
    key: "baseURI",
    get: function get() {
      return documentBaseURLSerialized(this._ownerDocument);
    }
  }, {
    key: "nodeValue",
    get: function get() {
      switch (this.nodeType) {
        case NODE_TYPE.ATTRIBUTE_NODE:
          {
            return this._value;
          }

        case NODE_TYPE.TEXT_NODE:
        case NODE_TYPE.CDATA_SECTION_NODE: // CDATASection is a subclass of Text

        case NODE_TYPE.PROCESSING_INSTRUCTION_NODE:
        case NODE_TYPE.COMMENT_NODE:
          {
            return this._data;
          }

        default:
          {
            return null;
          }
      }
    },
    set: function set(value) {
      if (value === null) {
        value = "";
      }

      switch (this.nodeType) {
        case NODE_TYPE.ATTRIBUTE_NODE:
          {
            attributes.setAnExistingAttributeValue(this, value);
            break;
          }

        case NODE_TYPE.TEXT_NODE:
        case NODE_TYPE.CDATA_SECTION_NODE: // CDATASection is a subclass of Text

        case NODE_TYPE.PROCESSING_INSTRUCTION_NODE:
        case NODE_TYPE.COMMENT_NODE:
          {
            this.replaceData(0, this.length, value);
            break;
          }
      }
    }
  }, {
    key: "textContent",
    get: function get() {
      switch (this.nodeType) {
        case NODE_TYPE.DOCUMENT_FRAGMENT_NODE:
        case NODE_TYPE.ELEMENT_NODE:
          {
            var text = "";

            var _iterator9 = _createForOfIteratorHelper(domSymbolTree.treeIterator(this)),
                _step9;

            try {
              for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
                var child = _step9.value;

                if (child.nodeType === NODE_TYPE.TEXT_NODE || child.nodeType === NODE_TYPE.CDATA_SECTION_NODE) {
                  text += child.nodeValue;
                }
              }
            } catch (err) {
              _iterator9.e(err);
            } finally {
              _iterator9.f();
            }

            return text;
          }

        case NODE_TYPE.ATTRIBUTE_NODE:
          {
            return this._value;
          }

        case NODE_TYPE.TEXT_NODE:
        case NODE_TYPE.CDATA_SECTION_NODE: // CDATASection is a subclass of Text

        case NODE_TYPE.PROCESSING_INSTRUCTION_NODE:
        case NODE_TYPE.COMMENT_NODE:
          {
            return this._data;
          }

        default:
          {
            return null;
          }
      }
    },
    set: function set(value) {
      switch (this.nodeType) {
        case NODE_TYPE.DOCUMENT_FRAGMENT_NODE:
        case NODE_TYPE.ELEMENT_NODE:
          {
            var child = domSymbolTree.firstChild(this);

            while (child) {
              this.removeChild(child);
              child = domSymbolTree.firstChild(this);
            }

            if (value !== null && value !== "") {
              this.appendChild(this._ownerDocument.createTextNode(value));
            }

            break;
          }

        case NODE_TYPE.ATTRIBUTE_NODE:
          {
            attributes.setAnExistingAttributeValue(this, value);
            break;
          }

        case NODE_TYPE.TEXT_NODE:
        case NODE_TYPE.CDATA_SECTION_NODE: // CDATASection is a subclass of Text

        case NODE_TYPE.PROCESSING_INSTRUCTION_NODE:
        case NODE_TYPE.COMMENT_NODE:
          {
            this.replaceData(0, this.length, value);
            break;
          }
      }
    }
  }]);

  return NodeImpl;
}(EventTargetImpl);

module.exports = {
  implementation: NodeImpl
};